if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');

      // ── SERENE: Click on main rotator advances to next image ────
      // Event delegation pattern: tek bir listener viewer üzerinde, aktif
      // image item'a tıklanınca bir sonrakine geç. Thumbnails check'inden
      // önce çalıştırılıyor ki tek görselli ürünlerde de bind kalsın
      // (advance fonksiyonu zaten 2'den az medya varsa no-op).
      if (this.elements.viewer) {
        this.elements.viewer.addEventListener('click', this.onViewerClick.bind(this));
        // Cursor pointer: aktif image item için (CSS ile de set edilebilirdi
        // ama JS daha taşınabilir — ileride CSS değişse de çalışsın).
        this.elements.viewer.querySelectorAll('.product__media-item').forEach((item) => {
          if (item.querySelector('.product__modal-opener--image')) {
            item.style.cursor = 'pointer';
          }
        });
      }

      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    onViewerClick(event) {
      // Aktif olmayan slide veya buton tıklamaları es geç
      if (event.target.closest('button')) return;
      if (event.target.closest('deferred-media, product-model, model-viewer, video, audio')) return;
      const item = event.target.closest('.product__media-item');
      if (!item) return;
      if (!item.classList.contains('is-active')) return;
      // Sadece görsel medya — video/3D'de native player çalışsın
      if (!item.querySelector('.product__modal-opener--image')) return;
      event.preventDefault();
      this.advanceToNextMedia();
    }

    advanceToNextMedia() {
      // Sadece üst seviye <li> elementlerini al — iç içe deferred-media
      // elementi de data-media-id taşıyor, onu sayma
      const items = Array.from(
        this.elements.viewer.querySelectorAll('.product__media-item[data-media-id]')
      );
      if (items.length < 2) return;
      const activeIndex = items.findIndex((el) => el.classList.contains('is-active'));
      const nextIndex = activeIndex < 0 || activeIndex >= items.length - 1 ? 0 : activeIndex + 1;
      const nextMedia = items[nextIndex];
      if (!nextMedia || !nextMedia.dataset.mediaId) return;
      this.setActiveMedia(nextMedia.dataset.mediaId, false);
    }

    advanceToPreviousMedia() {
      const items = Array.from(
        this.elements.viewer.querySelectorAll('.product__media-item[data-media-id]')
      );
      if (items.length < 2) return;
      const activeIndex = items.findIndex((el) => el.classList.contains('is-active'));
      const prevIndex = activeIndex <= 0 ? items.length - 1 : activeIndex - 1;
      const prevMedia = items[prevIndex];
      if (!prevMedia || !prevMedia.dataset.mediaId) return;
      this.setActiveMedia(prevMedia.dataset.mediaId, false);
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
